import { DateHelper } from '@/utils/helpers/date-helper';

export const toIsoDateString = (date: Date): string => DateHelper.formatToIsoDateString(date);
